export default __webpack_public_path__ + "static/media/LSSR_terms_of_use.2a6d89d2.pdf";